import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip, Stack, Autocomplete, TextField, Button } from '@material-ui/core';

import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import SearchIcon from '@mui/icons-material/Search';

import SearchSnapshotModal from './SearchSnapshotModal';
import useVrackApi from '../../../hooks/useVrackApi';
import SnapshotPreviewModal from '../../team/SnapshotPreviewModal';

SelectRackSnapshot.propTypes = {
  selectedSnapshot: PropTypes.object,
  setSelectedSnapshot: PropTypes.func
};

export default function SelectRackSnapshot({ selectedSnapshot, setSelectedSnapshot }) {
  const handleSnapshotChange = (event, newValue) => {
    setSelectedSnapshot(newValue);
  };

  const [searchOpen, setSearchOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [snapshotList, setSnapshotList] = useState([]);
  const { fetchData: vrackApiGetSnapshot } = useVrackApi('get', `/racks/snapshot`);
  const identity = useSelector((state) => state.identity.value);

  const getSnapshotList = async () => {
    try {
      const res = await vrackApiGetSnapshot({
        method: 'get',
        url: `/racks/snapshot?global=true&identity=${identity}`
      });

      setSnapshotList(res);
    } catch (err) {
      console.error('Failed to get snapshots list', err);
    }
  };

  useEffect(() => {
    getSnapshotList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SearchSnapshotModal
        isOpen={searchOpen}
        closeHandler={() => {
          setSearchOpen(false);
        }}
        snapshots={snapshotList}
        setSelectedSnapshot={setSelectedSnapshot}
      />
      <SnapshotPreviewModal
        isOpen={previewOpen}
        setIsOpen={setPreviewOpen}
        data={selectedSnapshot}
      />
      <Stack direction="row" spacing={1} alignItems="center">
        <Autocomplete
          size="small"
          options={snapshotList}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.name === value.name}
          sx={{ width: '250px' }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a Snapshot"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white'
                }
              }}
            />
          )}
          value={selectedSnapshot}
          onChange={handleSnapshotChange}
        />
        <Button
          startIcon={<SearchIcon />}
          variant="outlined"
          onClick={() => {
            setSearchOpen(true);
          }}
          sx={{ height: 40 }}
        >
          Search
        </Button>
        <Tooltip title="Preview Snapshot" placement="top">
          <span>
            <Button
              startIcon={<InfoOutlineIcon />}
              variant="outlined"
              onClick={() => setPreviewOpen(true)}
              disabled={!selectedSnapshot}
              sx={{ height: 40 }}
            >
              Preview
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </>
  );
}
